import { TranslatePipe } from '../../filters/translate.pipe';
import { SymptomCheckResultsComponent } from '../../components/symptom-check/symptom-check-results.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import RestService from '../../services/core-rest.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'symptom-check-simple',
	templateUrl: './symptom-check-simple.component.html',
	imports: [
		CommonModule, TranslatePipe, SymptomCheckResultsComponent, 
		FormsModule, RouterLink
	]
})
export default class SymptomCheckSimpleView implements OnInit {
	private restService: RestService = inject(RestService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('symptomCheck').then(() => {
			if (!this.vm.parentCategoryConfig) {
				this.restService.getPreVisitTicketConfig({ 'parentCategory': 'NEW_HEALTH_PROBLEM' })
					.then((parentCategoryConfig) => {
						this.vm.parentCategoryConfig = parentCategoryConfig;
						this.onResolve();
					});
			} else {
				this.onResolve();
			}
		});
	}
	
	onResolve() {
		this.vm.showStep1 = true;
		this.vm.showStep2 = false;
	}
	
	nextStep() {
		if (!this.vm.problemDescription) {
			this.vm.stepInvalid = true;
			return;
		}
		this.vm.showStep1 = false;
		this.vm.showStep2 = true;
	}
}